import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import {
  Button,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Row,
  Col,
  Tabs,
  Tab,
  Card,
} from "react-bootstrap";
// import "./View_ProjectDetails.css";
import {
  IconCalendarWeek,
  IconChevronDown,
  IconCopy,
  IconChevronRight,
  IconCopyCheck,
  IconEdit,
  IconFileTypePdf,
  IconPhoto,
  IconMail,
  IconMapPin,
  IconPaperclip,
  IconPhone,
  IconLink,
  IconShare,
  IconUser,
  IconFileTypeDoc,
  IconClockHour3,
  IconUserCircle,
  IconRefreshDot,
  IconEye,
} from "@tabler/icons-react";
import moment from "moment";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { useLocation } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const IMG = process.env.REACT_APP_BASE_URL_IMG;

function ViewBugDetails({ showPopup, onClose }) {
  const [bugData, setBugData] = useState(null);
  const [show, setShow] = useState(false);
  const [bugId, setBugId] = useState("");

  const { data: fetchedBug, postData: fetchProject } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_BUG
  );

  useEffect(() => {
    if (window.location.search && showPopup) {
      const autoId = window.location.search.slice(1);
      setBugId(autoId);
      fetchProject({ auto_id: autoId });
    }
  }, [window.location.search]);

  useEffect(() => {
    if (fetchedBug?.data) {
      setBugData(fetchedBug);
      setShow(true);
    }
  }, [fetchedBug]);

  const handleClose = () => {
    setShow(false);
    onClose(); // Trigger the close function passed from the parent

    const newUrl = window.location.pathname;
    window.history.pushState(null, "", newUrl);
  };

  const downloadImage = async (e, item) => {
    e.preventDefault();

    const imageUrl = `${BASE_URL}/common/download/${item?.file_name}`;
    const customFileName = item.original_name;

    try {
      const response = await fetch(imageUrl, {
        method: "GET",
      });

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", customFileName || "download.jpg");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <>
      <Offcanvas
        name="Detail"
        show={showPopup}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="flex_profit_row">
              <p className="mb-0">
                <h4 className="profit_est">
                  <b>{fetchedBug?.bug?.title}</b>
                </h4>
              </p>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="head_mini_details">
            <div className="flex_profit_row">
              <p className="mb-0">
                <b className="profit_est">Created By:</b>{" "}
                {fetchedBug?.bug?.User?.first_name || ""}{" "}
                {fetchedBug?.bug?.User?.last_name || ""}
              </p>
              <p className="mb-0">
                <b className="profit_est">Created Date:</b> <IconCalendarWeek />{" "}
                {moment(fetchedBug?.bug?.createdAt).format("MM/DD/YYYY")}
              </p>
            </div>
            <div className="flex_profit_row">
              <p className="mb-0">
                <b className="profit_est">Stage:</b>{" "}
                {fetchedBug?.bug?.status || "N/A"}
              </p>
              <p className="mb-0">
                <b className="profit_est">Priority:</b>{" "}
                <span
                  className={`badge ${
                    fetchedBug?.bug?.priority === "MEDIUM"
                      ? "bg-yellow text-yellow-fg"
                      : ""
                  } 
              ${
                fetchedBug?.bug?.priority === "LOW"
                  ? "bg-cyan text-cyan-fg"
                  : ""
              } 
              ${
                fetchedBug?.bug?.priority === "HIGH"
                  ? "bg-orange text-orange-fg"
                  : ""
              } 
              ${
                fetchedBug?.bug?.priority === "CRITICAL"
                  ? "bg-red text-red-fg"
                  : ""
              }`}
                >
                  {fetchedBug?.bug?.priority || "N/A"}
                </span>
              </p>
            </div>
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={12} md={5}>
                <p className="mb-0">
                  <b className="profit_est">Description:</b>{" "}
                </p>
                <p className="mt-1">{fetchedBug?.bug?.description || "N/A"}</p>
              </Col>{" "}
            </Row>
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={12} md={5}>
                <p className="mb-0">
                  <b className="profit_est">Steps to Reproduce:</b>{" "}
                </p>
                <p className="mt-1">
                  {fetchedBug?.bug?.steps_reproduce || "N/A"}
                </p>
              </Col>{" "}
            </Row>
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={12} md={5}>
                <p className="mb-0">
                  <b className="profit_est">Expected Behaviour:</b>{" "}
                </p>
                <p className="mt-1">
                  {fetchedBug?.bug?.expected_behavior || "N/A"}
                </p>
              </Col>{" "}
            </Row>
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={12} md={5}>
                <p className="mb-0">
                  <b className="profit_est">Actual Behaviour:</b>{" "}
                </p>
                <p className="mt-1">
                  {fetchedBug?.bug?.actual_behavior || "N/A"}
                </p>
              </Col>{" "}
            </Row>
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={12} md={5}>
                <p className="mb-0">
                  <b className="profit_est">Browser/Environment Details:</b>{" "}
                </p>
                <p className="mt-1">
                  {fetchedBug?.bug?.browser_details || "N/A"}
                </p>
              </Col>{" "}
            </Row>
          </div>

          <div className="attetchment_row">
            <p>
              <IconPaperclip stroke={1} width={20} /> Attachments{" "}
              <span>({fetchedBug?.bug?.Attachments.length || 0})</span>
            </p>
            <div className="carousel-container">
              {fetchedBug?.bug?.Attachments &&
              fetchedBug?.bug?.Attachments.length > 0 ? (
                <>
                  <Swiper
                    slidesPerView={3}
                    spaceBetween={15}
                    loop={true}
                    navigation={true}
                    modules={[Navigation]}
                    className="mySwiper"
                  >
                    {fetchedBug?.bug?.Attachments.map((item, index) => {
                      const fileExtension = item.original_name
                        .split(".")
                        .pop()
                        .toLowerCase();

                      let fileIcon;
                      if (fileExtension === "pdf") {
                        fileIcon = (
                          <IconFileTypePdf
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#D63939" }}
                          />
                        );
                      } else if (
                        [
                          "jpg",
                          "jpeg",
                          "png",
                          "gif",
                          "bmp",
                          "svg",
                          "webp",
                        ].includes(fileExtension)
                      ) {
                        fileIcon = (
                          <IconPhoto
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#AE3EC9" }}
                          />
                        );
                      } else {
                        fileIcon = (
                          <IconFileTypeDoc
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#4299E1" }}
                          />
                        );
                      }
                      return (
                        <SwiperSlide key={index} className="mySwiper">
                          <div className="card">
                            {item.type === "LINK" ? (
                              <a
                                href={item?.file_name}
                                target="_blank"
                                className="attetch_flex"
                              >
                                <IconLink
                                  stroke={1}
                                  width={45}
                                  height={45}
                                  style={{ color: "#4299E1" }}
                                />
                                <div className="attetch_info">
                                  <b>{item.original_name}</b>
                                  <p className="d-flex gap-3 mb-0">
                                    <span>LINK</span>
                                  </p>
                                </div>
                              </a>
                            ) : (
                              <div className="attetch_flex">
                                <div>{fileIcon}</div>
                                <div className="attetch_info">
                                  <b>{item.original_name}</b>
                                  <p className="d-flex gap-3 mb-0">
                                    <span
                                      onClick={(e) => {
                                        downloadImage(e, item);
                                      }}
                                    >
                                      Download
                                    </span>
                                    <a
                                      className="text-blue"
                                      href={`${IMG}uploads/attachments/${item.file_name}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Preview
                                    </a>
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </>
              ) : (
                <p>No Attachments available</p>
              )}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default ViewBugDetails;
